/**
 * Helpers for persisting an in-progress practice-quiz session across page
 * refreshes.  Each record is keyed per-user so multiple accounts on the same
 * device don't clash.
 *
 * Shape: { quizId, subject, savedAt }
 */
const KEY = (userId) => `aqSess_${userId}`;

export const saveActiveQuizSession = (userId, data) => {
  if (!userId) return;
  try {
    localStorage.setItem(KEY(userId), JSON.stringify({ ...data, savedAt: Date.now() }));
  } catch (_) {}
};

export const getActiveQuizSession = (userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(KEY(userId));
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const clearActiveQuizSession = (userId) => {
  if (!userId) return;
  try {
    localStorage.removeItem(KEY(userId));
  } catch (_) {}
};
